/**
 * RISK-TYPE-CHIP
 * Chip component to indicate risk type (RPS/PHY)
 */

import { faHeartPulse, faHelmetSafety } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Chip from "@/components/chip"
import Tooltip from "@/components/tooltip"
import { t } from "i18next"

interface RiskTypeChipProps {
  isRps: boolean
  count?: number
  showCount?: boolean
  color?: string
  isSmall?: boolean
  showLabel?: boolean
  disableTooltip?: boolean
  tooltipPosition?: "top" | "bottom" | "left" | "right"
  onClick?: () => void
  isOutlineColored?: boolean
}

export default function RiskTypeChip({
  isRps,
  count,
  showCount = true,
  color,
  isSmall,
  showLabel = true,
  disableTooltip = false,
  tooltipPosition = "top",
  onClick,
  isOutlineColored: isOutlineColoredProp = true
}: RiskTypeChipProps) {
  const icon = isRps ? faHeartPulse : faHelmetSafety
  const label = isRps ? t("rps") : t("PHY")
  const typeText = isRps ? "Risques Psychosociaux" : "Risques Physiques"
  const tooltipText = count !== undefined && count !== null && showCount ? `${typeText} ${count}` : typeText

  // Si pas de count et pas de label, afficher juste un circle
  if (!showCount && !showLabel) {
    const circle = (
      <div
        className={`rounded-full flex items-center justify-center ${disableTooltip ? "cursor-pointer" : "cursor-help"}`}
        style={{
          width: isSmall ? "20px" : "24px",
          height: isSmall ? "20px" : "24px",
          backgroundColor: color || "#ccc",
          border: `1px solid ${color || "#ccc"}`
        }}>
        <FontAwesomeIcon
          icon={icon}
          style={{
            fontSize: isSmall ? "10px" : "12px",
            color: "white"
          }}
        />
      </div>
    )
    return disableTooltip ? (
      circle
    ) : (
      <Tooltip text={tooltipText} position={tooltipPosition}>
        {circle}
      </Tooltip>
    )
  }

  const chip = (
    <Chip
      icon={icon}
      isOutlineColored={isOutlineColoredProp}
      color={color}
      className={`${isSmall ? "text-sm" : ""} ${disableTooltip ? "cursor-pointer" : "cursor-help"}`}
      onClick={onClick}>
      {showLabel && <span>{label}</span>}
      {showCount && count !== undefined && count !== null && <span className={showLabel ? "ml-1" : ""}>{count}</span>}
    </Chip>
  )
  return disableTooltip ? (
    chip
  ) : (
    <Tooltip text={tooltipText} position={tooltipPosition}>
      {chip}
    </Tooltip>
  )
}
